// @context TGW-2311 トークルーム投稿の送信前 AI チェック（Web 版）。
//
//   ⚠️ 現状このコードは実行されない。唯一の呼び出し元 userfeed_send_form.js が
//   userfeed_reply_list.js:307 の `{hashedCompanyId && …}` でガードされており、
//   マウント元の show.html.erb が hashedCompanyId を渡さないため常に false になる。
//   フォームが再びマウントされたときに無警告の投稿経路が生まれないよう先に配線してある（§13）。
//
//   RN の confirmBeforePost と違い、ダイアログは含めず API 呼び出しだけを担う
//   （Web のモーダルは ref 経由で開くコンポーネントなので、Promise を返す関数に閉じ込められない）。
//   判定ロジックをここに寄せているのは、コンポーネントテストの層が薄いため
//   （docs/talkroom_ai_warning_spec.md §17）。
import axios from '../components/axios';

// サーバー側の OpenAI 待ちは 4 秒。前後処理（セマフォ・予算・ChatgptUsageLog・INSERT）を
// 足しても収まる長さにする。ここを短くするとサーバーの unavailable 判定を受け取れず、
// 「判定できた／できなかった」の記録とユーザーの実際の体験がずれる。
export const PRECHECK_TIMEOUT_MS = 8000;

export const PRECHECK_PATH = '/api/userfeeds/ai_precheck';

/**
 * 送信前 AI チェック。{ warn, precheckId, title, message } を返す。
 *
 * 判定できない場合（status: 'unavailable'）と機能 OFF（'disabled'）、通信エラー、非 200、
 * タイムアウトはすべて { warn: false, precheckId: null }（fail-open）。
 * 呼び出し元は warn を見てモーダルを出す。
 *
 * 分岐は warn の真偽 1 本に絞る。status で分岐を書くと unavailable の扱いを
 * RN と Web のどちらか片方だけ間違える余地が残る（サーバーは judged 以外で必ず warn: false を返す）。
 *
 * precheckId は警告の有無にかかわらず、判定できていれば必ず返す。
 * warn と混ぜると「警告が出なかった投稿がどれだけ投稿されたか」という分母が取れなくなる。
 *
 * body には投稿 API に送るのと同一の文字列を渡すこと。サーバー側の digest 照合に落ちると、
 * 投稿されたことが記録されない。
 *
 * @param {{ body: string, userfeedId?: number }} params
 * @returns {Promise<{ warn: boolean, precheckId: ?number, title: ?string, message: ?string }>}
 */
export const requestPrecheck = async ({ body, userfeedId }) => {
  const failOpen = { warn: false, precheckId: null, title: null, message: null };

  try {
    const response = await axios.post(
      PRECHECK_PATH,
      { body, userfeed_id: userfeedId },
      { timeout: PRECHECK_TIMEOUT_MS }
    );
    const data = response && response.data;
    if (!data || data.status !== 'judged') return failOpen;

    return {
      warn: data.warn === true,
      precheckId: data.precheck_id != null ? data.precheck_id : null,
      // 文言はサーバーが返すものをそのまま表示する（クライアントに埋め込まない）。
      title: data.title || null,
      message: data.message || null,
    };
  } catch (error) {
    return failOpen;
  }
};
